import { render, staticRenderFns } from "./InspectorViews.vue?vue&type=template&id=a54b5e6a&"
import script from "./InspectorViews.vue?vue&type=script&lang=js&"
export * from "./InspectorViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports